// File: app/src/components/ChatInput.jsx
import React, { useState } from 'react';

export default function ChatInput({ onSend }) {
  const [input, setInput] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!input.trim()) return;
    onSend(input);
    setInput('');
  };

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        padding: '1rem',
        borderTop: '1px solid #E5E7EB',
        display: 'flex',
        alignItems: 'stretch',
        gap: '0.5rem'
      }}
    >
      <textarea
        style={{
          flex: 1,
          resize: 'none',
          border: '1px solid #E5E7EB',
          borderRadius: '0.375rem',
          padding: '0.5rem',
          height: '48px',
          outline: 'none'
        }}
        value={input}
        onChange={(e) => setInput(e.target.value)}
        placeholder="Ask me anything..."
      />
      <button
        type="submit"
        style={{
          backgroundColor: '#2563EB',
          color: 'white',
          borderRadius: '0.375rem',
          padding: '0 1rem',
          height: '48px',
          minWidth: '60px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'transform 0.2s',
          cursor: 'pointer',
          border: 'none',
          fontWeight: '500'
        }}
        aria-label="Send message"
        onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
        onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
      >
        Send
      </button>
    </form>
  );
}
